import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { LanguageService } from '../language/language.service';

@Component({
    selector: 'pw-footermodule',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
    @Input() facebookURL = '';
    @Input() footer: TemplateRef<unknown> | null = null;





}
